import request from '_utils/request'

// 信息发布列表
export function listAll(data) {
    return request({
      url: '/web_api/message/release/queryList',
      method: 'post',
      data: data
    })
  }
export function listInfo(id) {
    return request({
      url: '/web_api/message/release/'+id,
      method: 'get',
    })
  }
export function listInfos(data) {
    return request({
      url: '/web_api/duty/ZDNEWS/list',
      method: 'post',
      data: data
    })
  }
// 信息发布列表
export function listTeam(data) {
    return request({
      url: '/web_api/fire/team/list',
      method: 'post',
      data: data
    })
  }
  // 机构人员
export function listPeople(data) {
    return request({
      url: '/web_api/fire/team/queryList',
      method: 'post',
      data: data
    })
  }
  // 机构
export function listOrgan(data) {
    return request({
      url: '/web_api/system/dept/listQt',
      method: 'get',
      params: data
    })
  }

  // 专题专栏
export function listspecial(data) {
    return request({
      url: '/web_api/special/column/queryList',
      method: 'post',
      data: data
    })
  }
  export function addboard(data) {
    return request({
      url: '/web_api/message/board',
      method: 'post',
      data: data
    }) 
  }
  // 值班表
  export function listduty(data) {
    return request({
      url: '/web_api/duty/duty/list',
      method: 'post',
      data: data
    }) 
  }
  // 值班表
  export function listzhongdui(data) {
    return request({
      url: '/web_api/duty/dept/list',
      method: 'post',
      data: data
    }) 
  }
  // 值班岗位表
  export function listdutyconfig(data) {
    return request({
      url: '/web_api/duty/config/list',
      method: 'post',
      data: data
    }) 
  }
  // 值班岗位表
  export function listsuspend(data) {
    return request({
      url: '/web_api/special/workWindow/list',
      method: 'post',
      data: data
    }) 
  }
  // 值班岗位表
  export function listhyperlink(data) {
    return request({
      url: '/web_api/message/hyperlink/list',
      method: 'post',
      data: data
    }) 
  }
  // 部门网站
  export function listwork(data) {
    return request({
      url: '/web_api/special/work/list',
      method: 'post',
      data: data
    }) 
  }
  // 业务系统
  export function listbusiness(data) {
    return request({
      url: '/web_api/duty/business/list',
      method: 'post',
      data: data
    }) 
  }

// 查询协同报送表格大样
export function formSampleList(data) {
    return request({
      url: "/web_api/duty/submission/list",
      method: "post",
      data: data,
    });
}
// 查询协同报送表格大样
export function listReleaseCopy(data) {
  return request({
    url: '/web_api/message/releaseCopy/list',
    method: 'post',
    data: data
  })
}
// 修改浏览次数
export function updateRelease(data) {
  return request({
    url: '/web_api/message/release',
    method: 'put',
    data: data
  })
}
  
